import React, { useState, createRef, useEffect } from "react";
import Cropper, { ReactCropperElement } from "react-cropper";
import {
  Stack,
  Button,
  Typography,
  Grid,
  IconButton,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import RotateRightIcon from "@mui/icons-material/RotateRight";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import CropIcon from "@mui/icons-material/Crop";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import deleteicon from "../../Components/assets/Images/trashred.svg";
import "cropperjs/dist/cropper.css";
import "../../App.css";
import CachedIcon from "@mui/icons-material/Cached";
import { uploadDocumentsAPICall } from "../../shared/APICalls";
import { LoadingButton } from "@mui/lab";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import CropperStyles from "./ReactCropper.module.scss";

interface Props {
  imageSource: any;
  callBackImage: any;
  // documentRef:string
  // callBackDocumentId:any;
}

export const ReactCropper: React.FC<Props> = ({
  imageSource,
  callBackImage,
  // documentRef,
  // callBackDocumentId
}) => {
  const [image, setImage] = useState(imageSource);
  const [cropData, setCropData] = useState("#");
  const cropperRef = createRef<ReactCropperElement>();
  const [initialImage, setInitialImage] = useState(imageSource);
  const [loading, setloading] = useState(false);

  const handleCloseCropper = () => {
    callBackImage("close");
  };

  const getCropData = () => {
    if (typeof cropperRef.current?.cropper !== "undefined") {
      setloading(false);
      callBackImage(cropperRef.current?.cropper);
      // setCropData(cropperRef.current?.cropper.getCroppedCanvas().toDataURL());
    }
  };

  const rotateImage = () => {
    const imageElement = cropperRef?.current;
    const cropper: any = imageElement?.cropper;
    cropper.rotate(90);
  };
  const rotateImageLeft = () => {
    cropperRef.current?.cropper.rotate(-90);
  };
  const zoomIn = () => {
    cropperRef.current?.cropper.zoom(0.1);
  };

  const zoomOut = () => {
    cropperRef.current?.cropper.zoom(-0.3);
  };

  const downloadImage = () => {
    const a = document.createElement("a");
    a.href = cropData;
    a.download = "cropped_image.png";
    a.click();
  };

  const resetCropper = () => {
    setImage(initialImage);
    setCropData("#");
    cropperRef.current?.cropper.reset();
  };

  return (
    <>
      <Stack
        style={{ width: "100%" }}
        alignItems={"center"}
        paddingLeft={"5px"}
      >
        <Stack
          width={"100%"}
          alignItems={"flex-start"}
          direction={"row"}
          justifyContent={"space-between"}
          // padding={"10px 20px 10px 20px"}
          borderBottom={"1px solid var(--ds-outline)"}
          marginBottom={"20px"}
          sx={{
            padding: { xs: "10px 5px", sm: "10px 20px 10px 20px" },
          }}
        >
          <div className={CropperStyles.headerSection}>
            <div className={CropperStyles.title}> Upload & Preview</div>
            <div className={CropperStyles.desc}>
              Ensure the document is clear and high quality
            </div>
          </div>

          <IconButton
            style={{
              zIndex: "100",
              border: "1px solid var(--ds-outline)",
              borderRadius: "8px",
              display: "flex",
              justifyContent: "center",
            }}
            onClick={handleCloseCropper}
          >
            <img src={deleteicon} alt="" style={{ width: "18px" }} />
          </IconButton>
        </Stack>

        <Typography
          style={{
            position: "absolute",
            right: "13%",
            top: "13%",
            zIndex: "100",
            fontWeight: 500,
            fontFamily: "inherit !important",
          }}
          variant="h6"
          sx={{ display: { xs: "none", md: "flex" } }}
        >
          Preview
        </Typography>

        <Stack width={"100%"} direction={"row"}>
          <Cropper
            ref={cropperRef}
            className={CropperStyles.cropperSection}
            // style={{ height: 400, width: "80%" }}
            zoomTo={-1}
            initialAspectRatio={16 / 9}
            preview=".img-preview"
            src={image}
            viewMode={1}
            minCropBoxHeight={100}
            minCropBoxWidth={100}
            background={false}
            responsive={true}
            autoCropArea={1.8}
            checkOrientation={false}
            guides={true}
          />

          <div className="img-preview" id={CropperStyles.previewSection} />
        </Stack>
      </Stack>

      <Stack
        sx={{
          position: { xs: "relative", sm: "absolute" },
          bottom: { xs: "0px", sm: "20px" },
          borderTop: {
            xs: "0px solid var(--ds-outline)",
            sm: "1px solid var(--ds-outline)",
          },
          padding: { xs: " 0px 10px", sm: "10px 20px" },
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          marginTop: { xs: "10px", sm: "0" },
          alignItems: { xs: "center", sm: "unset" },
        }}
      >
        <Grid
          container
          // justifyContent="center"
          // marginLeft={{ xs: "10px", md: "80px" }}
          // width={"90%"}
          sx={{
            justifyContent: { xs: "center", sm: "unset" },
          }}
        >
          <Button
            variant="outlined"
            onClick={zoomIn}
            sx={{
              marginRight: "15px",
              marginTop: "10px",
              color: "var(--ds-text-primary)",
              border: "1px solid var(--ds-outline)",
              // height: "40px",
              padding: { xs: "4px 5px", sm: "5px 15px" },
              minWidth: "unset !important",
            }}
          >
            <AddIcon />
          </Button>
          <Button
            variant="outlined"
            onClick={zoomOut}
            sx={{
              marginRight: "15px",
              marginTop: "10px",
              color: "var(--ds-text-primary)",
              border: "1px solid var(--ds-outline)",
              padding: { xs: "4px 5px", sm: "5px 15px" },
              minWidth: "unset !important",
            }}
          >
            <RemoveIcon />
          </Button>
          <Button
            variant="outlined"
            onClick={rotateImageLeft}
            sx={{
              marginRight: "15px",
              marginTop: "10px",
              color: "var(--ds-text-primary)",
              border: "1px solid var(--ds-outline)",
              padding: { xs: "4px 5px", sm: "5px 15px" },
              minWidth: "unset !important",
            }}
          >
            <RotateLeftIcon />
          </Button>

          <Button
            variant="outlined"
            onClick={rotateImage}
            sx={{
              marginRight: "15px",
              marginTop: "10px",
              color: "var(--ds-text-primary)",
              border: "1px solid var(--ds-outline)",
              padding: { xs: "4px 5px", sm: "5px 15px" },
              minWidth: "unset !important",
            }}
          >
            <RotateRightIcon />
          </Button>
          <Button
            variant="outlined"
            onClick={resetCropper}
            sx={{
              marginRight: "15px",
              marginTop: "10px",
              color: "var(--ds-text-primary)",
              border: "1px solid var(--ds-outline)",
              padding: { xs: "4px 5px", sm: "5px 15px" },
              minWidth: "unset !important",
            }}
          >
            <CachedIcon /> Reset
          </Button>
        </Grid>{" "}
        <div className={CropperStyles.divider}></div>
        <LoadingButton
          sx={{
            marginRight: "15px",
            marginTop: "10px",
            boxShadow: "none",
            // height: "40px",
            width: { xs: "100%", sm: "187px" },
          }}
          variant="contained"
          onClick={() => {
            setloading(true);
            setTimeout(() => {
              getCropData();
            }, 50);
          }}
          type="submit"
        >
          {loading ? (
            <CircularProgress
              style={{ width: "25px", height: "25px", color: "inherit" }}
            />
          ) : (
            "Apply & save"
          )}
        </LoadingButton>
      </Stack>
    </>
  );
};

export default ReactCropper;
